import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatTableModule } from '@angular/material/table'
import { MatIconModule } from '@angular/material/icon'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { MatTooltipModule } from '@angular/material/tooltip'
import {
  FeaturesConfigModule,
  UrlModule,
  ConfigModule,
  I18nModule,
} from '@spartacus/core'
import { CmsPageGuard } from '@spartacus/storefront'
import { RouterModule } from '@angular/router'

import { UserManagementComponent } from './user-management.component'
import { from } from 'rxjs'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RoleMatrixModule } from '../my-profile/personal-detail/role-matrix/role-matrix.module'
import { environment } from '../../../../environments/environment'

@NgModule({
  declarations: [UserManagementComponent],
  imports: [
    CommonModule,
    FeaturesConfigModule,
    UrlModule,
    ConfigModule,
    MatTableModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    BrowserAnimationsModule,
    MatTooltipModule,
    I18nModule,
    RoleMatrixModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['userManagement'],
        },
      },
    }),
  ],
  exports: [UserManagementComponent],
})
export class UserManagementModule {}
